import { call, put, takeLatest, cancelled } from "redux-saga/effects"
import axios from "axios"
import { deleteAmbassadorApi, createAmbassadorApi } from "services/ambassador"
import {
  GET_EMPLOYEES_DIVISIONS_WATCHER,
  CREATE_AMBASSADOR_WATCHER,
  LIST_AMBASSADORS_WATCHER,
  DELETE_AMBASSADOR_WATCHER,
  GET_TEMPLATE_WATCHER,
  GET_LANGUAGE_WATCHER,
} from "./constants"
import {
  getEmployeesDivisionsFailed,
  getEmployeesDivisionsSuccess,
  listAmbassadorsSuccess,
  listAmbassadorsFailed,
  createAmbassadorSuccess,
  createAmbassadorFailed,
  listAmbassadorsWatcher,
  deleteAmbassadorSuccess,
  deleteAmbassadorFailed,
  getTemplateSuccess,
  getTemplateFailed,
  getLanguageSuccess,
  getLanguageFailed,
} from "./actions"
import { LOCAL_TOKEN } from "../../../../utils/storage"

function messageProgress(messagex) {
  message.loading(messagex, 0)
}

function messageDestroy() {
  message.destroy()
}

function donwloadTemplate(url) {
  location.replace(url)
}

// GET LANGUAGE
export function getLanguageApi() {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}language/`,
  })
}
export function* getLanguageSaga() {
  try {
    const {
      data: { data },
    } = yield call(getLanguageApi)

    yield put(getLanguageSuccess(data))
  } catch (error) {
    yield put(getLanguageFailed())
    returnMessage(error)
  }
}

function getTemplateApi(params) {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}ambassadors/export/xlsx`,
    params: { dates: params },
  })
}

function getTemplateApiProgress() {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}ambassadors/export/xlsx/progress`,
    validateStatus: (status) => true, // I'm always returning true,
  })
}

export function getEmployeesDivisionsApi(params) {
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}ambassadors/create`,
  })
}

export function getAmbassadorsApi(params) {
  let url = "ambassadors?q=&"
  if (params && params.payload) {
    if (params.payload.sortField) {
      let field = "e.first_name"
      if (params.payload.sortField === "divisions") {
        field = "d.name"
      } else if (params.payload.sortField === "last_name") {
        field = "e.last_name"
      }
      url += `&field_sort=${field}&order_sort=${params.payload.sortOrder}`
    }
    if (params.payload.search) {
      url += `&search=${params.payload.search}`
    }
  }
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
  })
}

export function* getEmployeesDivisionsSaga(params) {
  const cancelSource = axios.CancelToken.source()
  try {
    params.token = cancelSource.token
    const data = yield call(getEmployeesDivisionsApi, params)
    const result = {
      employees: data.data.data.result.employees,
      divisions: data.data.data.result.divisions,
    }
    yield put(getEmployeesDivisionsSuccess(result))
  } catch (error) {
    yield put(getEmployeesDivisionsFailed())
    returnMessage(error)
  }
}

  export function getAmbassadorsApiv2(params) {
    let url = "v2/ambassadors?q=&"
    if (params && params.payload) {
      if (params.payload.sortField) {
        let field = "e.first_name"
        if (params.payload.sortField === "divisions") {
          field = "d.name"
        } else if (params.payload.sortField === "last_name") {
          field = "e.last_name"
        }
        url += `&field_sort=${field}&order_sort=${params.payload.sortOrder}`
      }
      if (params.payload.search) {
        url += `&search=${params.payload.search}`
      }
    }
    return axios.request({
      method: "GET",
      cancelToken: params.token,
      headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
      url: `${process.env.API_URL + url}`,
    })
  }

export function* listAmbassadorsSaga(params) {
  const cancelSource = axios.CancelToken.source()
  try {
    params.token = cancelSource.token
    const data = yield call(getAmbassadorsApiv2, params)
    yield put(listAmbassadorsSuccess(data.data.data.result))
  } catch (error) {
    yield put(listAmbassadorsFailed())
    returnMessage(error)
  }
}

export function* createAmbassadorSaga(params = false) {
  const cancelSource = axios.CancelToken.source()
  try {
    params.token = cancelSource.token
    const data = yield call(createAmbassadorApi, params)
    yield put(createAmbassadorSuccess(data.data))
    yield put(listAmbassadorsWatcher())
    returnMessage(data)
  } catch (e) {
    returnMessage(e)
    yield put(createAmbassadorFailed({}))
  } finally {
    if (yield cancelled()) {
      cancelSource.cancel()
    }
  }
}

export function* deleteAmbassadorSaga(params = false) {
  const cancelSource = axios.CancelToken.source()
  try {
    params.token = cancelSource.token
    const data = yield call(deleteAmbassadorApi, params)
    yield put(deleteAmbassadorSuccess({}))
    yield put(listAmbassadorsWatcher())
    returnMessage(data)
  } catch (e) {
    returnMessage(e)
    yield put(deleteAmbassadorFailed({}))
  } finally {
    if (yield cancelled()) {
      cancelSource.cancel()
    }
  }
}

export function* getTemplateSaga(action) {
  try {
    yield call(messageProgress, "Descargando archivo")
    yield call(getTemplateApi, action.payload)
    let data
    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 2000))
      data = yield call(getTemplateApiProgress)
      if (data.status === 200) {
        yield call(donwloadTemplate, data.data.data.result[0].url)
        yield call(messageDestroy)
        returnMessage(data)
        yield put(getTemplateSuccess())
        break
      }
      if (data.status === 500) {
        yield call(messageDestroy)
        message.error(data.data.data.error, 5)
        yield put(getTemplateFailed())
        break
      }
    }
  } catch (e) {
    yield call(messageDestroy)
    returnMessage(e)
    yield put(getTemplateFailed())
  }
}

export default function* controlPanelUserManagementAmbassadorSaga() {
  yield takeLatest(GET_EMPLOYEES_DIVISIONS_WATCHER, getEmployeesDivisionsSaga)
  yield takeLatest(LIST_AMBASSADORS_WATCHER, listAmbassadorsSaga)
  yield takeLatest(CREATE_AMBASSADOR_WATCHER, createAmbassadorSaga)
  yield takeLatest(DELETE_AMBASSADOR_WATCHER, deleteAmbassadorSaga)
  yield takeLatest(GET_TEMPLATE_WATCHER, getTemplateSaga)
  yield takeLatest(GET_LANGUAGE_WATCHER, getLanguageSaga)
}
